import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@mui/icons-material/Search';
import RotateRightIcon from '@mui/icons-material/RotateRight';

import { IIdName } from '~/services/api/types';
import { IIcd10CodesFilters } from '~/services/api/icd10Codes/types';
import { allOption } from '~/ui/constants/allOptions';
import Input from '~/ui/components/inputs/Input';
import Select from '~/ui/components/inputs/Select';
import Button from '~/ui/components/common/Button';
import getInitialFilters from './form';

import styles from './Header.module.scss';

interface IProps {
  selectors: IIdName[];
  onSubmit: (filters: IIcd10CodesFilters) => void;
}

const Header = ({ selectors, onSubmit }: IProps) => {
  const initialFilters = getInitialFilters();

  const formMethods = useForm<IIcd10CodesFilters>({
    defaultValues: initialFilters,
  });

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = formMethods;

  const authorOptions = useMemo(
    () => [
      allOption,
      ...selectors.map(item => ({
        value: item.id,
        label: item.name,
      })),
    ],
    [selectors],
  );

  return (
    <FormProvider {...formMethods}>
      <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Input
              name="search"
              register={register}
              errors={errors}
              label="Search"
              placeholder="Search by Code / Description"
            />
          </Grid>
          <Grid item xs={3}>
            <Select
              name="userId"
              control={control}
              errors={errors}
              options={authorOptions}
              label="Author"
            />
          </Grid>
          <Grid item xs />
          <Grid item>
            <Button variant="outlined" type="submit" color="primary" startIcon={<SearchIcon />}>
              Search
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              type="button"
              startIcon={<RotateRightIcon />}
              onClick={() => {
                reset(initialFilters);
                onSubmit(initialFilters);
              }}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default Header;
